'use client';

import React from 'react';
import { useInView } from 'react-intersection-observer';
import { pushSelectPromotion, pushViewPromotion } from '@theme/utils/gtm';

interface ViewTrackerProps {
  children: React.ReactNode;
  eventType?: 'view_promotion' | 'select_promotion';
  eventData?: Record<string, unknown>;
  threshold?: number;
  once?: boolean;
  id?: string;
}

export default function ViewTracker({
  children,
  eventType,
  eventData,
  threshold = 0.5,
  once = true,
  id
}: ViewTrackerProps) {
  const { ref, inView } = useInView({
    threshold,
    triggerOnce: once
  });

  React.useEffect(() => {
    if (inView && eventType) {
      try {
        if (eventType === 'view_promotion') {
          pushViewPromotion(eventData);
        }
        if (eventType === 'select_promotion') {
          pushSelectPromotion(eventData);
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error in ViewTracker:', error);
      }
    }
  }, [inView, eventType, eventData]);

  return (
    <div ref={ref} data-view-tracker-id={id} className="w-full h-full">
      {children}
    </div>
  );
}
